"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildrenWrapper = exports.ErrorSummaryWrapper = exports.SavingWrapper = exports.SecondaryBtn = exports.PrimaryBtn = exports.ButtonWrapper = exports.ShareBtn = exports.ProjectLabel = exports.ActionContainer = exports.LogoContainerBox = exports.LogoContainer = exports.ProjectContainer = exports.InitialsButtonWrapper = exports.UserSettingsMenuWrapper = exports.HorizontalLine = exports.HeaderWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 5;
`;
exports.HeaderWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 16px;
`;
exports.HorizontalLine = styled_components_1.default.hr `
  border: 1px solid ${colors_1.PALE_GREEN};
  margin: 0;
`;
exports.UserSettingsMenuWrapper = styled_components_1.default.div `
  position: absolute;
  width: max-content;
  top: 33px;
  right: 3px;
  z-index: 10;
  ${({ $hidden }) => $hidden && `display:none;`}
`;
exports.InitialsButtonWrapper = styled_components_1.default.div `
  position: relative;
`;
exports.ProjectContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
exports.LogoContainer = styled_components_1.default.a `
  display: flex;
`;
exports.LogoContainerBox = styled_components_1.default.div `
  display: flex;
  margin-right: 10px;
`;
exports.ActionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;
exports.ProjectLabel = styled_components_1.default.label `
  display: flex;
  align-items: center;
  margin: 2px 12px 0;

  label {
    font-size: 16px;
  }

  & input[type="text"] {
    height: 24px;
  }
`;
exports.ShareBtn = styled_components_1.default.div `
  & button {
    text-transform: uppercase;
    color: ${colors_1.BLUE};
    &:hover,
    &:active,
    &:focus {
      background-color: ${colors_1.WHITE} !important;
    }
  }
`;
exports.ButtonWrapper = styled_components_1.default.div ``;
exports.PrimaryBtn = styled_components_1.default.div `
  margin: 0 12px;
  & button {
    text-transform: uppercase;
    height: 32px;
    padding: 8px 16px;
    font-size: 12px;
  }

  ${({ $lastElement }) => $lastElement && `margin-right:0;`}
`;
exports.SecondaryBtn = styled_components_1.default.div `
  margin: 0 0 0 12px;

  & button {
    text-transform: uppercase;
    height: 32px;
    padding: 8px 16px;
    font-size: 12px;
  }
`;
exports.SavingWrapper = styled_components_1.default.div `
  color: ${colors_1.GREY3};
  font-size: 12px;
  margin-top: 3px;
  display: flex;
`;
exports.ErrorSummaryWrapper = styled_components_1.default.div `
  margin-right: 21px;
`;
exports.ChildrenWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=HeaderCompact.styles.js.map